import validator from 'email-validator';
import { ActionTypes } from './actions';

const initialState = {
    isMessageSent: false,
    emailValid: true,
    firstNameValid: true,
    lastNameValid: true,
    submitError: false,
};

export default function inviteDoctorFormReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.INPUT_DOCTORS_EMAIL:
            return {
                ...state,
                doctorsEmail: action.payload.email,
                emailValid: validator.validate(action.payload.email),
            };

        case ActionTypes.INPUT_FIRST_NAME:
            return {
                ...state,
                firstName: action.payload.firstName,
                firstNameValid: true,
            };

        case ActionTypes.INPUT_LAST_NAME:
            return {
                ...state,
                lastName: action.payload.lastName,
                lastNameValid: true,
            };

        case ActionTypes.EMAIL_INVALID:
            return {
                ...state,
                emailValid: false,
            };

        case ActionTypes.FIRST_NAME_INVALID:
            return {
                ...state,
                firstNameValid: false,
            };

        case ActionTypes.LAST_NAME_INVALID:
            return {
                ...state,
                lastNameValid: false,
            };

        case ActionTypes.SUBMIT_FORM_FAILURE:
            return {
                ...state,
                submitError: true,
            };

        case ActionTypes.SUBMIT_FORM_SUCCESS:
            return {
                ...state,
                isMessageSent: true,
            };

        default:
            return state;
    }
}
